import { intl } from "LocaleWrapper";
import { Select } from "@cofano/cck";
import { InactivityType } from "__generated__/enums";
import { SelectProps } from "@cofano/cck/Select/Select";

const InactivityTypeSelect = ({
	...rest
}: Omit<SelectProps<InactivityType, false>, "fetchOptions" | "paginated" | "getOptionLabel" | "disableSearch">) => (
	<Select
		fetchOptions={Object.values(InactivityType)}
		getOptionLabel={option => intl.formatMessage({ id: `${option}_TIME` })}
		disableSearch
		{...rest} />
);

export default InactivityTypeSelect;
